import * as React from 'react';
import {NavLink} from 'react-router-dom';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import {Trad} from '../components/';
import {NavItem} from "./NavItem";
import {NavDropdownItem} from "./NavDropdownItem";

interface INavMainState {
    Menu?: Dati.CRisAPIListaMenu;
    Caricamento: boolean;
    Main: string;
    Mobile: boolean;
}

export class NavMain extends React.PureComponent<Glob.IGlobaleProps, INavMainState> {
    public constructor(props: any) {
        super(props);
        this.state = {
            Menu: undefined,
            Caricamento: true,
            Main: "Vuoto",
            Mobile: window.innerWidth < 768
        };
    }

    public componentDidMount() {
        this.AggiornaMenu();

        window.addEventListener("resize", this.OnRidimensiona.bind(this));
    }

    public componentDidUpdate() {
        this.AggiornaMenu();
    }

    public OnRidimensiona() {
        this.setState({Mobile: window.innerWidth < 768});
    }

    private AggiornaMenu() {
        let Menu = Glob.GetMenu();
        if (Menu != undefined && Menu.Main != undefined && Menu.Main != this.state.Main) {
            Glob.Log(Glob.LogCat.Menu, false, "AggiornaMenu Main", Menu.Main, this.state.Main);
            this.setState({Main: Menu.Main})
            fetch('/api/Menu/Main?sessione=' + Glob.GetSessione().Sessione + "&main=" + Menu.Main)
                .then(response => {
                    if (response.ok) {
                        response.text().then(text => {
                            let data = JSON.parse(text, Glob.DateReviver) as Dati.CRisAPIListaMenu;
                            this.setState({Menu: data, Caricamento: false});
                        }).catch(e => Glob.Log(Glob.LogCat.Menu, false, "Errore caricamento NavMain (JSON)", e));
                    } else {
                        Glob.Log(Glob.LogCat.Menu, true, "Errore caricamento NavMain (HTTP)", response);
                    }
                })
                .catch(e => Glob.Log(Glob.LogCat.Menu, true, "Errore caricamento NavMain (Rete)", e));
        }
    }

    public render() {
        let VociMenu = this.state.Caricamento
            ? <p><em>{Trad.Trad("Caricamento...")}</em></p>
            : this.renderVociMenu();

        return VociMenu;
    }

    private sottoMenuAzioni(azioni?: Dati.IAzioniMenu[], id_funzione?: Glob.Funzioni): React.ReactNode {
        if (azioni == undefined || id_funzione == undefined)
            return true;

        var azioniHTML: any[] = [];
        for (var i = 0; i < azioni.length; i++) {
            if (Glob.AzioneAbilitata(id_funzione, azioni[i].Abilitazione)) {
                azioniHTML.push(
                    <NavDropdownItem action={Trad.Trad(azioni[i].Azione)} icon={azioni[i].Icona}
                                     key={i} url={azioni[i].URL}/>
                )
            }
        }

        return <ul className="kt-menu__subnav">
            {azioniHTML}
        </ul>;
    }

    private menuPadre(dato: Dati.IDatiMenu): React.ReactNode {
        if (dato.Azioni == undefined || dato.Azioni.length == 0) {
            return <NavLink className="kt-menu__link" to={dato.Indirizzo}>
                <span className="kt-menu__link-text">
                    <span className={'fa ' + dato.Icona}></span>
                    {Trad.Trad(dato.Voce)}
                </span>
            </NavLink>
        } else {
            return <a className="kt-menu__link kt-menu__toggle" id={'Menu_' + dato.Voce}>
                <span className="kt-menu__link-text">
                    <span className={'fa ' + dato.Icona}></span>
                    {Trad.Trad(dato.Voce)}
                </span>
                <i className="kt-menu__hor-arrow la la-angle-down"></i>
                <i className="kt-menu__ver-arrow la la-angle-right"></i>
            </a>
        }
    }

    private popolaSottoMenu(azioni?: Dati.IAzioniMenu[], id_funzione?: Glob.Funzioni): React.ReactNode {
        if (azioni == undefined || azioni.length == 0 || id_funzione == undefined) {
            return true;
        } else {
            return <div
                className="kt-menu__submenu kt-menu__submenu--classic kt-menu__submenu--left">
                <span className="kt-menu__arrow kt-menu__arrow--adjust"
                      style={{left: 72.73}}></span>
                {this.sottoMenuAzioni(azioni, id_funzione)}
            </div>
        }
    }

    private renderVociMenu() {
        if ((this.state.Menu == undefined) || (this.state.Menu.Dati == undefined)) {
            return <span>{Trad.Trad("Errore")}</span>;
        }
        return this.state.Menu.Dati.map(dato =>
            <NavItem key={dato.ID_Menu}
                     cssClass={"kt-menu__item kt-menu__item--submenu kt-menu__item--rel"}>
                {this.menuPadre(dato)}
                {this.popolaSottoMenu(dato.Azioni, dato.ID_Funzione)}
            </NavItem>
        );
    };
}



// WEBPACK FOOTER //
// ./src/layout/NavMain.tsx